import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Menu, Icon, Button, Header, Modal, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  SemanticButton,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { cleanTagsHtml } from "../../../../utils/Utils";
import { isAuthAdmin } from "../../../../services/auth";

const ListarQuestoes = (props) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [questoes, setQuestoes] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadAuth();
    loadQuestoes();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };
  const loadQuestoes = async () => {
    try {
      const response = await api.get("admin/simulado/questao");
      const { data } = response;
      let array = { local: "Questoes", texto: `listou as questoes` };
      await api.post("system_logs", { acao: JSON.stringify(array) });
      setLoading(false);

      setQuestoes(data);
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      swal(
        "Não foi possível as encontrar as questões",
        "",
        "error"
      ).then((res) => props.history.push("/"));
    }
  };

  const removeQuestao = useCallback(
    (id) => {
      swal("Remoção de questão", "Você tem certeza que quer remover ?", "").then(
        (res) => {
          if (res) {
            api.delete(`admin/simulado/questao/${id}`).then(async (res) => {
              let array = {
                local: "Questoes",
                texto: `deletou a questao de id=${id}`,
              };
              await api.post("system_logs", { acao: JSON.stringify(array) });
              const newQuestoes = [...questoes].filter(
                (questao) => questao.id !== id
              );
              setQuestoes(newQuestoes);
            });
          }
        }
      );
    },
    [questoes]
  );
  const cleanHTML = (valor) => {
    const html = cleanTagsHtml(valor);
    const string = html.substring(0, 10);
    if (html.length > 11) {
      const value = `${string}...`;
      return value;
    }
    return string;
  };
  const diminuirString = (valor) => {
    const string = valor.substring(0, 10);
    if (valor.length > 11) {
      const value = `${string}...`;
      return value;
    }
    return string;
  };

  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Questões</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar questão..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />

              <CreateButton to="/admin/questoes/criar">Criar</CreateButton>
            </ContainerInputSearch>

            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell style={{ width: "8%" }}>
                    #Id
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "10%" }}>
                    Simulado
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "10%" }}>
                    Enunciado
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "10%" }}>
                    imagem
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "10%" }}>
                    Opção A
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "10%" }}>
                    Opção B
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "10%" }}>
                    Opção C
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "10%" }}>
                    Opção D
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "10%" }}>
                    Correta
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "8%" }}>
                    Ação
                  </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>

              <SemanticTable.Body>
                {questoes
                  .filter((questao) =>
                    questao.enunciado
                      .toLowerCase()
                      .includes(search.toLowerCase())
                  )
                  .map((questao, index) => (
                    <SemanticTable.Row>
                      <SemanticTable.Cell>#{questao.id}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {questao?.simulado?.titulo}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {cleanHTML(questao.enunciado)}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {diminuirString(questao.imagem)}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {diminuirString(questao.a)}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {diminuirString(questao.b)}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {diminuirString(questao.c)}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {diminuirString(questao.d)}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>{questao.correta}</SemanticTable.Cell>

                      <SemanticTable.Cell>
                        <>
                          <Button
                            icon="edit icon"
                            color={"blue"}
                            onClick={() =>
                              window.open(
                                `/admin/questoes/detalhes/${questao.id}`
                              )
                            }
                          />
                        </>
                      </SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))}
              </SemanticTable.Body>
            </SemanticTable>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(ListarQuestoes);
